import {inject} from '@angular/core';
import {HttpInterceptorFn} from '@angular/common/http';
import {SessionStore} from './stores/session.store';
import {TokenRefreshService} from './services/token-refresh.service';
import {catchError, EMPTY, from, switchMap, throwError} from 'rxjs';
import { AuthFacade } from "./facade/auth.facade";

const PUBLIC_ENDPOINTS = [
	'/login',
	'/refresh',
	'/forgot-password'
];

export const authInterceptor: HttpInterceptorFn = (req, next) => {

	const session = inject(SessionStore);
	const refreshService = inject(TokenRefreshService);
	const facade = inject(AuthFacade);

	if (isPublicEndpoint(req.url)) {
		return next(req);
	}

	const token = session.authToken();

	const authReq = token
		? req.clone({
			setHeaders: {
				userToken: token,
				Authorization: `Bearer ${token}`
			}
		})
		: req;

	return next(authReq).pipe(
		catchError(err => {

			if (err.status !== 401) {
				return throwError(() => err);
			}

			if (req.url.includes('/user/logout')) {
				return throwError(() => err);
			}

			return from(refreshService.refreshToken()).pipe(
				switchMap(newToken => {

					if (!newToken) {
						facade.logout();
						return EMPTY;
					}

					const retryReq = req.clone({
						setHeaders: {
							userToken: newToken,
							Authorization: `Bearer ${newToken}`
						}
					});

					return next(retryReq);
				}),
				catchError(() => {
					facade.logout();
					return EMPTY;
				})
			);

		})
	);
};

function isPublicEndpoint(url: string): boolean {
	return PUBLIC_ENDPOINTS.some(p => url.includes(p));
}
